<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    {{this.Title}}
</h1>

<form>
    <div mat-dialog-content>
        <p [ngClass]="!this.JobInitiated ? 'active-p' : 'idle-p'">{{this.ImportDescription}}</p>
    </div>

    <div>
        <span>Select Import File: </span>

        <ng-container *ngIf="!this.AllowMultipleFiles">
            <input type="file"
                   #file
                   accept=".xlsx,.xls"
                   style="display: none"
                   (change)="this.onFileAdded()" />
        </ng-container>

        <button [disabled]="this.JobInitiated"
                mat-raised-button
                color="primary"
                class="add-file-btn theme-primary-btn"
                (click)="this.selectImportFile()">
            Select File ...
        </button>
    </div>

    <div style="margin-top: 10px; margin-bottom: 10px;">
        <span>File: </span>
        <span>{{this.SelectedFileName}}</span>
    </div>

    <div class="execution-time-div">
        <span>Execution Time:</span>
        <span [ngClass]="this.JobInProgress ? 'active-execution-time-span' : 'idle-execution-time-span'">{{this.JobTimeElapsed}}</span>
    </div>

    <div class="execution-status-div">
        <span>Execution Status:</span>
        <span [ngClass]="this.JobCompleted ? 'completed-execution-status-span' : 'incomplete-execution-status-span'">{{this.ImportStatus}}</span>
    </div>

    Execution Summary:
    <div #executionSummary id="execution-summary-div" class="execution-summary-div">
        <p [ngClass]="this.JobErrorOccurred ? 'execution-summary-p execution-summary-with-error-p' : 'execution-summary-p execution-summary-without-error-p'" data-placeholder="Details will display here ...">
            <span>{{ExecutionSummaryText}}</span>
        </p>
    </div>

    <div *ngIf="ExecutionSummaryText">
        Copy Execution Summary:
        <button mat-icon-button class="copy-button" (click)="CopySummaryToClipboard()" title="Copy Execution Summary to Clipboard">
            <mat-icon class="copy-button-icon" id="copybutton">content_copy</mat-icon>
        </button>
    </div>

    <div mat-dialog-actions>
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="(!this.FileSelected) || this.JobInitiated"
                (click)="this.startImport()">
            Start Import ...
        </button>
        <button mat-flat-button
                type="submit"
                color="accent"
                [disabled]="!this.JobInitiated"
                (click)="this.dismiss()">
            Dismiss
        </button>

        <button mat-flat-button
                [disabled]="this.JobInitiated"
                [mat-dialog-close]="null"
                style="margin-left: 10px;"
                (click)="this.cancel()">
            Cancel
        </button>
    </div>

</form>
